import React from "react";
import { useTranslation } from "react-i18next";
import { Play, Square, RefreshCw } from "lucide-react";

interface PlaybackControlsProps {
  onPlay: () => void;
  onStop: () => void;
  looping: boolean;
  onToggleLoop: () => void;
}

const btnStyle: React.CSSProperties = {
  background: "none", border: "none", cursor: "pointer", padding: 4, color: "inherit",
};

export function PlaybackControls({ onPlay, onStop, looping, onToggleLoop }: PlaybackControlsProps) {
  const { t } = useTranslation();
  return (
    <>
      <button type="button" onClick={onPlay} aria-label={t("experiential.play")} title={t("experiential.play")} style={btnStyle}>
        <Play size={18} />
      </button>
      <button type="button" onClick={onStop} aria-label={t("experiential.stop")} title={t("experiential.stop")} style={btnStyle}>
        <Square size={18} />
      </button>
      <button
        type="button"
        onClick={onToggleLoop}
        aria-label={t("experiential.loop")}
        title={t("experiential.loop")}
        style={{ ...btnStyle, color: looping ? "var(--color-brand)" : "inherit" }}
      >
        <RefreshCw size={18} />
      </button>
    </>
  );
}
